import { Files } from '../../lib/constants/files'
import { CenterOlPayment } from '../../lib/types/models/center-ol-payment/center-ol-payment'
import { CenterOlPaymentInput } from '../../lib/types/models/center-ol-payment/center-ol-payment-input'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function createCenterOlPayment(data: CenterOlPaymentInput) {
  if (data.files) {
    const updatedFiles = []

    for (const file of data.files) {
      const uploadedFile = await uploadFile(Files.CENTER_OL_PAYMENT_INVOICES, file)
      if (!uploadedFile) throw new Error('File not uploaded')
      updatedFiles.push(uploadedFile)
    }

    data.files = updatedFiles
  }

  return restApiClient
    .url(API.centerOlPayments.create.url)
    .post<CenterOlPayment, CenterOlPaymentInput>(data)
}
